import { render, staticRenderFns } from "./productionStage.vue?vue&type=template&id=48c68b27&"
import script from "./productionStage.vue?vue&type=script&lang=js&"
export * from "./productionStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports